import React from 'react'
import {
    Box,
    Text,

    /* Hooks */
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'
import { FormattedMessage } from 'react-intl'

/* Styles */
import { useStoreLocatorStyles } from '../styles/storeLocatorStyles'

/* Hooks */
import { useStoreLocator } from '../../../contexts/store-locator-context';

/* Icons */
import { ChevronRightIcon } from '../../../components/icons'

const StoreLocatorStoreList = () => {
    /* Styling */
    const styles = useStoreLocatorStyles()
    const storeCardStyling = styles?.components?.storeCard
    const isMobile = useBreakpointValue({ base: true, lg: false })

    const {
        stores,
        setStoreCardRef,
        setActiveMarkerId,
        setSelectedStore,
        selectedStore,
        onOpenStoreDetails,
        getLocalizedHoursStatus,
        setToggleStoreInfo,
        permissionStatus
    } = useStoreLocator()

    const handleStoreInfoClick = (store) => {
        setActiveMarkerId(store?.id)
        setSelectedStore(store)

        if (isMobile) {
            onOpenStoreDetails()
            setToggleStoreInfo(true)
            return
        }

        onOpenStoreDetails()
    }

    return (
        <Box>
            {stores?.map((store, index) => {
                const hoursStatus = getLocalizedHoursStatus(store)

                return (
                    <Box key={index} {...storeCardStyling.container}
                        onClick={() => handleStoreInfoClick(store)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault()
                                e.stopPropagation()
                                handleStoreInfoClick(store)
                            }
                        }}
                        role="button"
                        tabIndex={0}
                        aria-label={`Info about store ${selectedStore?.name}`}
                        _focusVisible={{
                            margin: '3px'
                        }}>
                        <Box ref={setStoreCardRef(store?.id)} {...storeCardStyling.wrapper}>
                            <Box {...storeCardStyling.cardHeading}>
                                <Box {...storeCardStyling.nameAndDistance}>
                                    <Text {...storeCardStyling.name}>
                                        {store?.name}
                                    </Text>
                                    {permissionStatus === 'granted' &&
                                        <Text {...storeCardStyling.distance}>
                                            <FormattedMessage
                                                id='store_locator.input.distance'
                                                defaultMessage='{distance} {distanceUnit} away'
                                                values={{ distance: store?.distance, distanceUnit: store?.distanceUnit }}
                                            />
                                        </Text>
                                    }
                                </Box>
                                <ChevronRightIcon />
                            </Box>
                            <Box {...storeCardStyling.addressWrapper}>
                                <Text {...storeCardStyling.address}>
                                    {store?.address1}
                                </Text>
                                <Text {...storeCardStyling.address}>
                                    {store?.city}
                                    {(store?.stateCode || store?.state) ? `, ${store?.stateCode || store?.state}` : ''}
                                    {store?.postalCode ? `, ${store?.postalCode}` : ''}
                                </Text>
                            </Box>
                            <Box {...storeCardStyling.hoursWrapper}>
                                <Text {...styles.hours}>
                                    {hoursStatus?.status === 'OPEN_UNTIL' ? (
                                        <Box as="span" {...styles.dot} {...styles.greenDot}></Box>
                                    ) : (
                                        <Box as="span" {...styles.dot} {...styles.redDot}></Box>
                                    )}
                                    {hoursStatus?.message}
                                </Text>
                            </Box>
                        </Box>
                    </Box>
                )
            })}
        </Box>
    )
}

export default StoreLocatorStoreList
